// extracted by mini-css-extract-plugin
export default {"contact_container":"styles_contact_container__1UoUV","contact_sub_container":"styles_contact_sub_container__SHPCP","contact_title":"styles_contact_title__DLqsM"};